import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../../routes/routeKeys";
import UserProfile from "../../components/ProfileComponents/UserProfile";
import useAuth from "../../hooks/useAuth";
import BaseLayout from "../../layouts/BaseLayout";
import { BASE_URL } from "../../utils/Element";

const UserProfileDetail = () => {
  const { id } = useParams();
  const [config] = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [userData, setUserData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/user-getbyid/${id}`, config)
      .then((res) => {
        const value = res?.data?.data;
        setUserData(value);
      })
      .catch((err) => {
        setError(err.response.data.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  }, [id]);

  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get('search');

  return (
    <BaseLayout>
      <p role="button" className="green-H head-5 underline" onClick={() => navigate(`${ROUTES.USERS}?search=${searchValue || ''}`)}>
        Back to Users
      </p>
      <UserProfile from="users" userData={userData} loading={loading} />
    </BaseLayout>
  );
};    

export default UserProfileDetail;
